import { TASK_TYPES } from 'workflow/constants/newInbox';

export const getIdRequestByTypeName = task => {
    const { typeName, id, taskId } = task;
    if (typeName === TASK_TYPES.EVENT || typeName === TASK_TYPES.DOA) {
        return taskId;
    }
    return id;
};

export const getTypeNameByTaskId = (tasks, taskId) => {
    const { typeName } = tasks.find(({ id }) => id === taskId) || {};
    return typeName || '';
};
